import globalAxios from "../../../util/Api";
import { GET_CLASSIFICATIONS_LIST, STOP_LOADING, ERROR, DELETE_CLASSIFICATION, CREATE_CLASSIFICATION, EDIT_CLASSIFICATION, START_LOADING } from "./types";
import { LogoutAction } from "../../../actions";

export const GetClassifications = () => {
  return (dispatch) => {
    globalAxios().get(`/api/v1/classifications`)
      .then(res => {
        const newres = res.data.classifications.map(obj => {
          obj['name'] = obj['classification']
          delete obj['classification']
          return obj
        })
        if (newres) {
          dispatch({ type: GET_CLASSIFICATIONS_LIST, payload: newres })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}
export const CreateClassification = (classification, probability) => {
  let bodyFormData = new FormData();
  bodyFormData.append('classification[classification]', classification);
  bodyFormData.append('classification[probability]', probability);
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().post(`/api/v1/classifications`, bodyFormData)
      .then(res => {
        const newres = res.data.data
        newres['name'] = newres['classification']
        delete newres['classification']
        if (newres) {
          dispatch({ type: CREATE_CLASSIFICATION, payload: newres })
          dispatch(GetClassifications())
        }
      }).catch(err => {
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
      })
  }
}
export const EditClassification = (id, classificationFunc, probability) => {
  let bodyFormData = new FormData();
  bodyFormData.append('classification[classification]', classificationFunc);
  bodyFormData.append('classification[probability]', probability);

  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().patch(`/api/v1/classifications/${id}`, bodyFormData)
      .then(res => {
        const newres = res.data.data
        newres['name'] = newres['classification']
        delete newres['classification']
        if (newres) {
          dispatch({ type: EDIT_CLASSIFICATION, payload: newres })
          dispatch(GetClassifications())
        }
      }).catch(err => {
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
      })
  }
}
export const DeleteClassification = (id) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().delete(`/api/v1/classifications/${id}`)
      .then(res => {
        if (res) {
          dispatch({ type: DELETE_CLASSIFICATION })
          dispatch(GetClassifications())
        }
      }).catch(err => {
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
      })
  }
}
